module.exports = __webpack_public_path__ + "img/foodcourt-banner-pc.0874ef88.jpg";